//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { httpFetch } from "../../lib/fetch";
export class BaseXClient {

    private withCredentials: boolean;

    constructor(withCredentials: boolean = false) {
        this.withCredentials = withCredentials;
    }
    public transformOptions(options: RequestInit): Promise<RequestInit> {
        options.mode = "cors";
        if (options.headers)
            (<any>options.headers)["Content-Type"] = "text/plain"; //to avoid preflight requests

        options.credentials = this.withCredentials ? "include" : undefined;

        return Promise.resolve(options);
    }

    public onRequest<T>(options: RequestInit, url: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }, finalPromise: Promise<T>): Promise<Response> {
        let ap = finalPromise as ApiPromise<T>;
        ap.requestMetadata = new RequestMetadata(options, url);

        return http.fetch(url, options)
            .then(response_ => {
                ap.responseMetadata = new ResponseMetadata(response_);
                return response_;
            }, reason_ => {
                ap.responseMetadata = new ResponseMetadata({ ok: false });
                throw reason_;
            })
    }
}

export class ClientApi extends BaseXClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, withCredentials: boolean = false, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(withCredentials);
        this.http = http ? http : httpFetch;//<any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    track_Post_1(data: TrackEventData): Promise<TrackingResultFinal> {
        let url_ = this.baseUrl + "/api/rtde";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        const result: Promise<TrackingResultFinal> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processTrack_Post_1(_response);
            });
        return result;
    }

    protected processTrack_Post_1(response: Response): Promise<TrackingResultFinal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrackingResultFinal;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackingResultFinal>(null as any);
    }

    profileDebuggerEvent_Put_2(scriptId: string | null, userId: string | null, model: DebuggerEventModel): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/user/profileDebuggerEvent?";
        if (scriptId === undefined)
            throw new Error("The parameter 'scriptId' must be defined.");
        else if(scriptId !== null)
            url_ += "scriptId=" + encodeURIComponent("" + scriptId) + "&";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };

        const result: Promise<void> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processProfileDebuggerEvent_Put_2(_response);
            });
        return result;
    }

    protected processProfileDebuggerEvent_Put_2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    log_Post_3(log: LogModel): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/client/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(log);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };

        const result: Promise<void> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processLog_Post_3(_response);
            });
        return result;
    }

    protected processLog_Post_3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resolvePlaceholder_Post_3(userId: string | null, organizationId: string | null, collectionId: string | null, data: GetUserDataBase): Promise<RenderPlaceholderResult> {
        let url_ = this.baseUrl + "/api/v3/user/resolvePlaceholder?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === undefined)
            throw new Error("The parameter 'organizationId' must be defined.");
        else if(organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (collectionId === undefined)
            throw new Error("The parameter 'collectionId' must be defined.");
        else if(collectionId !== null)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        const result: Promise<RenderPlaceholderResult> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processResolvePlaceholder_Post_3(_response);
            });
        return result;
    }

    protected processResolvePlaceholder_Post_3(response: Response): Promise<RenderPlaceholderResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenderPlaceholderResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenderPlaceholderResult>(null as any);
    }

    actionEvent_Post_3(userId: string | null, organizationId: string | null, collectionId: string | null, campaignId: string | null, actionId: string | null, issuedActionId: string | null, data: TrackActionEventBase): Promise<InnerAction> {
        let url_ = this.baseUrl + "/api/v3/user/action/event?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === undefined)
            throw new Error("The parameter 'organizationId' must be defined.");
        else if(organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (collectionId === undefined)
            throw new Error("The parameter 'collectionId' must be defined.");
        else if(collectionId !== null)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (campaignId === undefined)
            throw new Error("The parameter 'campaignId' must be defined.");
        else if(campaignId !== null)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (actionId === undefined)
            throw new Error("The parameter 'actionId' must be defined.");
        else if(actionId !== null)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (issuedActionId === undefined)
            throw new Error("The parameter 'issuedActionId' must be defined.");
        else if(issuedActionId !== null)
            url_ += "issuedActionId=" + encodeURIComponent("" + issuedActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        const result: Promise<InnerAction> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processActionEvent_Post_3(_response);
            });
        return result;
    }

    protected processActionEvent_Post_3(response: Response): Promise<InnerAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InnerAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InnerAction>(null as any);
    }

    actionRevert_Post_3(userId: string | null, organizationId: string | null, collectionId: string | null, actionId: string | null, data: UnissuedActionBase): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/user/action/revert?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === undefined)
            throw new Error("The parameter 'organizationId' must be defined.");
        else if(organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (collectionId === undefined)
            throw new Error("The parameter 'collectionId' must be defined.");
        else if(collectionId !== null)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (actionId === undefined)
            throw new Error("The parameter 'actionId' must be defined.");
        else if(actionId !== null)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };

        const result: Promise<void> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processActionRevert_Post_3(_response);
            });
        return result;
    }

    protected processActionRevert_Post_3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    userCookie_Get_3(cookieName: string | null, getOnly: boolean | undefined): Promise<UserCookieModel> {
        let url_ = this.baseUrl + "/api/v3/client/userCookie?";
        if (cookieName === undefined)
            throw new Error("The parameter 'cookieName' must be defined.");
        else if(cookieName !== null)
            url_ += "cookieName=" + encodeURIComponent("" + cookieName) + "&";
        if (getOnly === null)
            throw new Error("The parameter 'getOnly' cannot be null.");
        else if (getOnly !== undefined)
            url_ += "getOnly=" + encodeURIComponent("" + getOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            },
        };

        const result: Promise<UserCookieModel> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processUserCookie_Get_3(_response);
            });
        return result;
    }

    protected processUserCookie_Get_3(response: Response): Promise<UserCookieModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCookieModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCookieModel>(null as any);
    }

    userCookie_Put_3(cookieName: string | null, model: UserCookieModel): Promise<UserCookieModel> {
        let url_ = this.baseUrl + "/api/v3/client/userCookie?";
        if (cookieName === undefined)
            throw new Error("The parameter 'cookieName' must be defined.");
        else if(cookieName !== null)
            url_ += "cookieName=" + encodeURIComponent("" + cookieName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        const result: Promise<UserCookieModel> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processUserCookie_Put_3(_response);
            });
        return result;
    }

    protected processUserCookie_Put_3(response: Response): Promise<UserCookieModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCookieModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCookieModel>(null as any);
    }

    userCookie_Delete_3(cookieName: string | null, keepLocal: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v3/client/userCookie?";
        if (cookieName === undefined)
            throw new Error("The parameter 'cookieName' must be defined.");
        else if(cookieName !== null)
            url_ += "cookieName=" + encodeURIComponent("" + cookieName) + "&";
        if (keepLocal === null)
            throw new Error("The parameter 'keepLocal' cannot be null.");
        else if (keepLocal !== undefined)
            url_ += "keepLocal=" + encodeURIComponent("" + keepLocal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            },
        };

        const result: Promise<boolean> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processUserCookie_Delete_3(_response);
            });
        return result;
    }

    protected processUserCookie_Delete_3(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    vwFreespee_Get_4(collectionId: string | null, userId: string | null): Promise<VwFreespeeUserDataModel> {
        let url_ = this.baseUrl + "/api/v4/user/vwFreespee?";
        if (collectionId === undefined)
            throw new Error("The parameter 'collectionId' must be defined.");
        else if(collectionId !== null)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            },
        };

        const result: Promise<VwFreespeeUserDataModel> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processVwFreespee_Get_4(_response);
            });
        return result;
    }

    protected processVwFreespee_Get_4(response: Response): Promise<VwFreespeeUserDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VwFreespeeUserDataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VwFreespeeUserDataModel>(null as any);
    }

    externalAction_Post_4(externalActionId: string | null, model: ExternalActionClientModel): Promise<ExternalActionResponse> {
        let url_ = this.baseUrl + "/api/v4/user/externalAction?";
        if (externalActionId === undefined)
            throw new Error("The parameter 'externalActionId' must be defined.");
        else if(externalActionId !== null)
            url_ += "externalActionId=" + encodeURIComponent("" + externalActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        const result: Promise<ExternalActionResponse> = this.transformOptions(options_)
            .then(options_ => this.onRequest(options_, url_, this.http, result))
            .then((_response: Response) => {
                return this.processExternalAction_Post_4(_response);
            });
        return result;
    }

    protected processExternalAction_Post_4(response: Response): Promise<ExternalActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalActionResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalActionResponse>(null as any);
    }
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface TrackingResultFinal {
    uIds?: UserId[] | undefined;
    actions?: FinalIssuedAction[] | undefined;
    handovers?: IssuedHandover[] | undefined;
    sampling?: UserSampling | undefined;
    operationProblems?: OperationProblems | undefined;
}

export interface UserId {
    id?: string | undefined;
    type: UserIdProviderType;
    lifeTime?: number | undefined;
}

export enum UserIdProviderType {
    Local = 1,
    CrossDomain = 2,
    LocalServerSide = 3,
    UrlParameter = 4,
}

export interface FinalIssuedAction {
    userId?: string | undefined;
    id?: string | undefined;
    actionId?: string | undefined;
    organizationId?: string | undefined;
    collectionId?: string | undefined;
    campaignId?: string | undefined;
    type: ActionType;
    conf?: IssuedAction | undefined;
    isInControlGroup: boolean;
    testMode: boolean;
    actionCategory: ActionCategory;
    actionClass: ActionClass;
    isManual: boolean;
    parentActionId?: string | undefined;
    issuedFollowUpActions?: FinalIssuedAction[] | undefined;
    dynamicProductId?: string | undefined;
    testModeOverride: boolean;
    campaignPotentialGroupId?: string | undefined;
    activeProductId?: string | undefined;
    actionCampaignPotentialGroupIds?: string[] | undefined;
    triggeredInnerAction: boolean;
    testLink: boolean;
    triggerUrl?: string | undefined;
    dynamicTopicId?: string | undefined;
    pageElementDetection?: PageElementDetection | undefined;
}

export enum ActionType {
    Cookie = 1,
    Overlay = 2,
    Script = 3,
    Html = 4,
    Voucher = 5,
    Pixel = 6,
    ProfileUpdate = 7,
}

export interface IssuedAction {
    id?: string | undefined;
    delayInSeconds: number;
    issuedFollowUpActions?: IssuedFollowUpAction[] | undefined;
    actionName?: string | undefined;
    executeForControlGroupUsers: boolean;
    actionId?: string | undefined;
    actionCategory: ActionCategory;
    actionClass: ActionClass;
    actionType: ActionType;
    metaInfoCampaign?: string | undefined;
    metaInfoCTA?: string | undefined;
    metaInfoBusinessTargetGroup?: string | undefined;
    metaInfoDesign?: string | undefined;
    listOfAllMetaInfoClickCTA?: string[] | undefined;
    metaInfoClickCTA?: string | undefined;
    metaInfoHandoverActive: boolean;
    metaInfoActionType?: string | undefined;
    templateTypeId?: string | undefined;
    templateVersion?: string | undefined;
}

export interface IssuedFollowUpAction {
    issuedAction?: IssuedAction | undefined;
    actionId?: string | undefined;
    issuedActionId?: string | undefined;
    actionCategory: ActionCategory;
    actionClass: ActionClass;
    actionType: ActionType;
}

export enum ActionCategory {
    Overlay = 1,
    Banderole = 2,
    Voucher = 3,
    Custom = 4,
    ScriptCustom = 5,
    Pixel = 6,
    Cookie = 7,
    ContentPersonalization = 8,
    InfoHandover = 9,
    ExternalOverlay = 10,
    Widget = 11,
    Notification = 12,
    ScriptOverlay = 13,
    ScriptBanderole = 14,
    ScriptWidget = 15,
    ScriptUxPersonalization = 16,
    Standard = 17,
    ScriptInfobox = 18,
}

export enum ActionClass {
    Visual = 1,
    Invisible = 2,
    PersoAsset = 3,
}

export interface NoIssuedAction extends IssuedAction {
}

export interface IssuedCookieAction extends IssuedAction {
    cookieName?: string | undefined;
    cookieValue?: string | undefined;
    lifeTime?: string | undefined;
    templateSyntaxType: TemplateSyntaxType;
    expireDays: number;
}

export enum TemplateSyntaxType {
    Mustache = 1,
    Scriban = 2,
}

export interface IssuedInjectHtmlAction extends IssuedAction {
    html?: string | undefined;
}

export interface IssuedInjectScriptAction extends IssuedAction {
    script?: string | undefined;
    actionConfigType: ActionConfigType;
    itemId?: string | undefined;
    itemType: ActionItemType;
    languageId?: string | undefined;
    contextAwareCapping: boolean;
    geoId?: string | undefined;
    conversionProductId?: string | undefined;
    pageClassProductId?: string | undefined;
    coreScript?: string | undefined;
    css?: string | undefined;
    flickerDefendingRequired: boolean;
    isModule: boolean;
    isCoreModule: boolean;
    isTestCode: boolean;
    customCssTemplateSyntaxType: TemplateSyntaxType;
    customCoreScriptTemplateSyntaxType: TemplateSyntaxType;
    scriptTemplateSyntaxType: TemplateSyntaxType;
    collectionActionGroups?: string[] | undefined;
    parameters?: UserActionContextParameters | undefined;
    allowAsynchronousProcessing: boolean;
}

export enum ActionConfigType {
    Simple = 1,
    ConversionProductDependent = 2,
    ProductRankDependent = 3,
    LastPageClassProductDependent = 4,
    ActiveProductDependent = 5,
    PageClassDependent = 6,
    TopicRankDependant = 7,
}

export enum ActionItemType {
    None = 0,
    Product = 1,
    PageClass = 2,
    Topic = 3,
}

export interface UserActionContextParameters {
    simple?: { [key: string]: UserActionContextParameter; } | undefined;
    linkCatalog?: { [key: string]: UserActionContextParameter; } | undefined;
}

export interface UserActionContextParameter {
    label?: string | undefined;
    value?: string | undefined;
}

export interface IssuedOverlayAction extends IssuedAction {
    url?: string | undefined;
    visualConfig?: VisualConfig | undefined;
    urlConfigType?: ActionConfigType | undefined;
    itemId?: string | undefined;
    itemType: ActionItemType;
    languageId?: string | undefined;
    contextAwareCapping: boolean;
    geoId?: string | undefined;
    conversionProductId?: string | undefined;
    pageClassProductId?: string | undefined;
    collectionActionGroups?: string[] | undefined;
    templateSyntaxType: TemplateSyntaxType;
    actionConfigType: ActionConfigType;
}

export interface VisualConfig {
    dimensions?: Dimensions | undefined;
    verticalSnap: VerticalSnap;
    horizontalSnap: HorizontalSnap;
    margin?: Margin | undefined;
    dimensionsState: DimensionsState;
    modal: boolean;
    closeButtonVisible: boolean;
    closeOnOuterClick: boolean;
    transparent: boolean;
    maxDynamicDimensionsEnabled: boolean;
    flexiblePositionIOS: boolean;
    slideIn?: Slide | undefined;
    fadeIn?: Fade | undefined;
    slideOut?: Slide | undefined;
    fadeOut?: Fade | undefined;
    boxShadow?: BoxShadow | undefined;
    displayPreventionDisabled: boolean;
}

export interface Dimensions {
    height?: ValueWithUnit | undefined;
    width?: ValueWithUnit | undefined;
}

export interface ValueWithUnit {
    value?: number | undefined;
    unit: Unit;
}

export enum Unit {
    Pixels = 1,
    Percent = 2,
}

export enum VerticalSnap {
    Center = 1,
    Bottom = 2,
    Top = 3,
}

export enum HorizontalSnap {
    Center = 1,
    Left = 2,
    Right = 3,
}

export interface Margin {
    top?: ValueWithUnit | undefined;
    bottom?: ValueWithUnit | undefined;
    left?: ValueWithUnit | undefined;
    right?: ValueWithUnit | undefined;
}

export enum DimensionsState {
    Dynamic = 1,
    Static = 2,
}

export interface Slide {
    slideSide: SlideSide;
    transition: number;
    enabled: boolean;
}

export enum SlideSide {
    Top = 1,
    Bottom = 2,
    Left = 3,
    Right = 4,
}

export interface Fade {
    transition: number;
    enabled: boolean;
}

export interface BoxShadow {
    enabled: boolean;
    horizontalOffset: number;
    verticalOffset: number;
    blur: number;
    spread: number;
    color?: string | undefined;
}

export interface IssuedVoucherAction extends IssuedOverlayAction {
    voucherTypeId?: string | undefined;
    voucherEngineConnectionId?: string | undefined;
    voucherId?: string | undefined;
    clientSideVariable?: string | undefined;
    voucherVariableName?: string | undefined;
    extractClientSideValue: boolean;
}

export interface IssuedPixelAction extends IssuedAction {
    url?: string | undefined;
    alt?: string | undefined;
    templateSyntaxType: TemplateSyntaxType;
}

export interface IssuedProfileUpdateAction extends IssuedAction {
    value?: string | undefined;
    actionConfigType: ActionConfigType;
    itemId?: string | undefined;
    itemType: ActionItemType;
    languageId?: string | undefined;
    contextAwareCapping: boolean;
    geoId?: string | undefined;
    conversionProductId?: string | undefined;
    pageClassProductId?: string | undefined;
    assetType: PersonalizationAssetType;
}

export enum PersonalizationAssetType {
    Json = 1,
    String = 2,
    Url = 3,
}

export interface PageElementDetection {
    querySelectors?: string[] | undefined;
    throttling: number;
}

export interface IssuedHandover {
    id?: string | undefined;
    isInControlGroup: boolean;
    conf?: DataExchangeConfig | undefined;
}

export interface DataExchangeConfig {
    dataExchangeType: DataExchangeType;
    placeholdersToCheck?: string[] | undefined;
}

export enum DataExchangeType {
    Script = 1,
    Cookie = 2,
    Pixel = 3,
    TrackingResponse = 4,
    GetApi = 5,
    PostApi = 6,
    CustomHandover1 = 7,
}

export interface UserSampling {
    selected: boolean;
    ratioVersion: number;
}

export interface OperationProblems {
    problems?: OperationProblem[] | undefined;
}

export interface OperationProblem {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface OperationValidationProblem extends OperationProblem {
    errors?: { [key: string]: string[]; } | undefined;
}

export interface TrackEventData {
    scriptVersion?: string | undefined;
    scriptId: string;
    uIds?: UserId2[] | undefined;
    event: string;
    eventObject?: string | undefined;
    url: string;
    urlReferrer?: string | undefined;
    title?: string | undefined;
    timezoneOffset: number;
    sampling?: ClientSampling | undefined;
    externalCookies?: ExternalCookieModel[] | undefined;
}

export interface UserId2 {
    id?: string | undefined;
    type: UserIdProviderType;
}

export interface ClientSampling {
    selected?: boolean | undefined;
    ratioVersion?: number | undefined;
    override?: boolean | undefined;
}

export interface ExternalCookieModel {
    system?: string | undefined;
    purpose?: string | undefined;
    context?: string | undefined;
    cookieName?: string | undefined;
    value?: string | undefined;
    partnerId?: string | undefined;
    partnerSystem?: string | undefined;
}

export interface DebuggerEventModel {
    url?: string | undefined;
    debuggerEventType: DebuggerEventType;
}

export enum DebuggerEventType {
    Opened = 1,
    Closed = 2,
    Minimized = 3,
}

export interface LogModel {
    severityLogLevel: SeverityLogLevel;
    logType: LogType;
    message?: string | undefined;
    data?: any | undefined;
    errorInfo?: ErrorInfo | undefined;
    context?: LogContext | undefined;
}

export enum SeverityLogLevel {
    Info = 2,
    Warn = 3,
    Error = 4,
}

export enum LogType {
    Internal = 0,
    External = 1,
}

export interface ErrorInfo {
    name?: string | undefined;
    message?: string | undefined;
    stack?: string | undefined;
}

export interface LogContext {
    userId?: string | undefined;
    scriptId?: string | undefined;
    collectionId?: string | undefined;
    campaignId?: string | undefined;
    actionId?: string | undefined;
}

export interface RenderPlaceholderResult {
    value?: any | undefined;
}

export interface GetUserDataBase {
    placeholder?: string | undefined;
}

export interface InnerAction {
    id?: string | undefined;
    innerActionType: InnerActionType;
    name?: string | undefined;
    closeOverlay: boolean;
    handovers?: IssuedHandover[] | undefined;
    metaInfoClickCTA?: string | undefined;
}

export enum InnerActionType {
    Basic = 1,
    Open = 2,
    Trigger = 3,
    CloseButton = 4,
}

export interface BasicInnerAction extends InnerAction {
}

export interface OpenInnerAction extends InnerAction {
    url?: string | undefined;
    newWindow: boolean;
}

export interface NoInnerAction extends InnerAction {
}

export interface TriggerInnerAction extends InnerAction {
    actionId?: string | undefined;
    issuedAction?: FinalIssuedAction | undefined;
}

export interface TrackActionEventBase {
    innerActionName?: string | undefined;
    actionEventType: ActionEventType;
    itemId?: string | undefined;
    itemType?: ActionItemType | undefined;
    languageId?: string | undefined;
    geoId?: string | undefined;
    actionCloseType?: ActionCloseType | undefined;
    templateTypeId?: string | undefined;
    templateVersion?: string | undefined;
}

export enum ActionEventType {
    OverlayOpened = 1,
    OverlayClosed = 2,
    Trigger = 3,
    OverlayDiscarded = 4,
    Submit = 5,
}

export enum ActionCloseType {
    NativeClose = 1,
    TemplateClose = 2,
    InnerActionClose = 3,
    SystemClose = 4,
}

export interface UnissuedActionBase {
    actionCategory: ActionCategory;
    itemId?: string | undefined;
    itemType?: ActionItemType | undefined;
}

export interface UserCookieModel {
    value: string;
    lifeTime?: number | undefined;
}

export interface VwFreespeeUserDataModel {
    preferredModel?: string | undefined;
    preferredModelInterestLevel?: string | undefined;
    configurationStatus?: string | undefined;
    configurationModel?: string | undefined;
    detailPageModel?: string | undefined;
    promoPageModel?: string | undefined;
    dealerCode?: string | undefined;
    modelCode?: string | undefined;
    modelDerivative?: string | undefined;
    campaignCode?: string | undefined;
}

export interface ExternalActionResponse {
    metadata?: ExternalActionRequestMetadata | undefined;
    result?: IExternalActionResult | undefined;
}

export interface ExternalActionRequestMetadata {
    organizationId?: string | undefined;
    collectionId?: string | undefined;
    campaignId?: string | undefined;
    userId?: string | undefined;
    userExternalActionId?: string | undefined;
    userCollectionId?: string | undefined;
    externalActionId?: string | undefined;
    externalActionType: ExternalActionType;
}

export enum ExternalActionType {
    VoucherReservation = 1,
    VoucherCreation = 2,
}

export interface IExternalActionResult {
}

export interface ExternalActionClientModel {
    userId: string;
    aditionalData?: string | undefined;
    token?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export interface ApiPromise<T> extends Promise<T> {
    requestMetadata?: RequestMetadata;
    responseMetadata?: ResponseMetadata;
}

export class RequestMetadata {
    headers?: HeadersInit;
    method?: string;
    mode?: RequestMode;
    url: string;
    date: Date;

    constructor(request: RequestInit, url: string) {
        this.headers = request.headers;
        this.method = request.method;
        this.mode = request.mode;
        this.url = url;
        this.date = new Date();
    }
}

export class ResponseMetadata {
    headers?: Headers;
    type?: ResponseType;
    ok: boolean;
    status?: number;
    date: Date;

    constructor(response: Response | { ok: boolean, status?: number }) {
        if (response instanceof Response) {
            this.headers = response.headers;
            this.type = response.type;
        }

        this.ok = response.ok;
        this.status = response.status;
        this.date = new Date();
    }
}